import * as React from "react";

import { dataGridColumn } from "../DataGridColumn";
import {
  createSelectedColumnState,
  getVisibleWatchingColumns,
  selectAllWatchingColumns,
} from "../utils/watchingUtils";

export function useWatchingColumnState() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [selectedColumn, setSelectedColumn] = React.useState(() =>
    createSelectedColumnState(dataGridColumn)
  );

  const open = Boolean(anchorEl);
  const visibleColumns = React.useMemo(
    () => getVisibleWatchingColumns(dataGridColumn, selectedColumn),
    [selectedColumn]
  );

  const handleOpenMenu = React.useCallback((event) => {
    setAnchorEl(event?.currentTarget);
  }, []);

  const handleCloseMenu = React.useCallback(() => {
    setAnchorEl(null);
  }, []);

  const handleSelectColumn = React.useCallback((field) => {
    setSelectedColumn((previousState) => ({
      ...previousState,
      [field]: !previousState[field],
    }));
  }, []);

  const handleSelectAllColumns = React.useCallback(() => {
    setSelectedColumn((previousState) =>
      selectAllWatchingColumns(previousState)
    );
  }, []);

  return {
    anchorEl,
    open,
    selectedColumn,
    visibleColumns,
    handleOpenMenu,
    handleCloseMenu,
    handleSelectColumn,
    handleSelectAllColumns,
  };
}
